import { useTranslation } from '@frontend/i18n';
import { RadioCardField, TextField, useControlledField } from '@frontend/design-system';
import { PracticeVertical, PracticeVerticalOption } from '../constants';
import { checkIsOtherVerticalSelected } from '../helpers';
import { radioCardStyles } from '../styles';

interface Props {
  verticalOptions: PracticeVerticalOption[];
  selectedVertical?: PracticeVertical;
  industryName?: string;
  setPracticeVertical: (vertical: PracticeVertical) => void;
  setIndustryName: (industryName: string) => void;
}

export const VerticalSelectionStep = ({
  verticalOptions,
  selectedVertical,
  setPracticeVertical,
  industryName,
  setIndustryName,
}: Props) => {
  const { t } = useTranslation('schedule-onboarding');

  const verticalRadioField = useControlledField({
    type: 'radio',
    required: true,
    value: selectedVertical,
    onChange: (value) => {
      // NOTE: in pointer-events: unset case, we receive undefined value when user click on that area
      // So to avoid that to reset radio selection, keeping this empty check
      if (!value) return;
      setPracticeVertical(value);
    },
  });

  const industryNameField = useControlledField({
    type: 'text',
    required: true,
    value: industryName,
    onChange: (value) => setIndustryName(value),
  });

  return (
    <RadioCardField animate name='practice-vertical' {...verticalRadioField} css={radioCardStyles.field}>
      {verticalOptions.map((vertical) => {
        const isOtherOptionSelected = checkIsOtherVerticalSelected(vertical.id, selectedVertical);
        return (
          <RadioCardField.Option
            key={vertical.id}
            value={vertical.id}
            title={vertical.name}
            css={[radioCardStyles.radioOption, isOtherOptionSelected && radioCardStyles.expandedRadioOption]}
            selectionContent={
              isOtherOptionSelected && (
                <TextField
                  autoFocus
                  name='industry-name'
                  label={t('Industry Name')}
                  css={radioCardStyles.input}
                  {...industryNameField}
                />
              )
            }
          />
        );
      })}
    </RadioCardField>
  );
};
